import { cn } from "admin-ui/utils/cn"
import { IconProps } from "."

export default function FilledStarBlue({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <path
        d="M8.13589 1.48359C8.52162 0.821321 9.47838 0.821321 9.86411 1.48359L12.011 5.16962C12.1523 5.41222 12.3891 5.58425 12.6635 5.64367L16.8326 6.54646C17.5816 6.70867 17.8773 7.6186 17.3666 8.1901L14.5244 11.371C14.3374 11.5803 14.2469 11.8587 14.2752 12.138L14.7049 16.382C14.7821 17.1445 14.0081 17.7069 13.3067 17.3978L9.40325 15.6777C9.14634 15.5645 8.85366 15.5645 8.59675 15.6777L4.69326 17.3978C3.99192 17.7069 3.21789 17.1445 3.2951 16.382L3.7248 12.138C3.75308 11.8587 3.66264 11.5803 3.47558 11.371L0.633386 8.1901C0.122732 7.6186 0.418384 6.70867 1.16744 6.54646L5.3365 5.64367C5.61089 5.58425 5.84767 5.41222 5.98897 5.16962L8.13589 1.48359Z"
        fill="#3B82F6"
      />
    </svg>
  )
}
